import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon36 = Icon( /*#__PURE__*/_jsx("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: 'new 0 0 40 40'
  },
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("g", {}, void 0, /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M7,10.7h26c1,0,1.9-0.8,1.9-1.9C34.9,7.8,34,7,33,7H7C6,7,5.1,7.8,5.1,8.9C5.1,9.9,6,10.7,7,10.7z"
}), /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M33,18.1H7c-1,0-1.9,0.8-1.9,1.9c0,1,0.8,1.9,1.9,1.9h26c1,0,1.9-0.8,1.9-1.9C34.9,19,34,18.1,33,18.1z"
}), /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M33,29.3H7c-1,0-1.9,0.8-1.9,1.9C5.1,32.2,6,33,7,33h26c1,0,1.9-0.8,1.9-1.9C34.9,30.1,34,29.3,33,29.3z"
}))));
export default SkholeIcon36;